<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            {{ $t("view.unresolved.title") }}
          </v-card-title>
          <v-card-subtitle>
            {{ getOrg }}
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <CaseReportTable
      :tableLoading="tableLoading"
      v-on:onViewCaseReport="openCaseReport"
      v-on:onMultiResolveClick="onMultiResolveClick"
      v-on:onMultiAssignClick="onMultiAssignClick"
    />

    <MultiResolution
      :visible="multiResolutionVisible"
      :loading="multiResolutionLoading"
      :totalSelectedCases="selectedCaseReports.length"
      v-on:onConfirm="onMultiResolveConfirmed"
      v-on:onCancelled="onMultiResolveCancelled"
    />

    <BulkAssign
      :visible="multiAssignVisible"
      :loading="multiAssignLoading"
      :totalSelectedCases="selectedCaseReports.length"
      v-on:onConfirm="onMultiAssignConfirmed"
      v-on:onCancelled="onMultiAssignCancelled"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CaseReportTable from "../components/CaseReportTable";
import MultiResolution from "../modals/case reports/MultiResolution";
import BulkAssign from "../modals/case reports/BulkAssign.vue";
export default {
  name: "Resolution",
  components: { CaseReportTable, MultiResolution, BulkAssign },
  computed: {
    ...mapGetters(["getOrg", "getProfile", "getAccount"]),
  },
  data() {
    return {
      resultsTableVisible: false,
      tableLoading: false,
      caseReport: {},
      selectedCaseReports: [],
      selectedSearchRecord: {},
      searchSummaryVisible: false,
      caseReportVisible: false,
      multiResolutionVisible: false,
      multiResolutionLoading: false,
      multiAssignVisible: false,
      multiAssignLoading: false,
      headers: [
        { text: "Date", value: "searchDate" },
        { text: "Cases", value: "cases" },
        { text: "User", value: "userName" },
        { text: "Matches", value: "matches" },
        { text: "View", value: "controls", sortable: false, align: "right" },
      ],
    };
  },
  methods: {
    ...mapActions([
      "setGlobalAlert",
      "fetchCaseGroups",
      "resolveCaseReports",
      "assignCaseReports",
      "updateCaseReportStatus",
    ]),
    created() {},
    openCaseReport(caseReport) {
      this.$router.push({
        name: "casereport",
        params: {
          caseReport: caseReport,
        },
      });
    },
    onSearchSummaryClose() {
      this.selectedSearchRecord = {};
      this.searchSummaryVisible = false;
    },
    onCaseReportClose() {
      this.caseReport = {};
      this.caseReportVisible = false;
    },
    onMultiResolveClick(selectedCaseReports) {
      this.selectedCaseReports = selectedCaseReports;
      this.multiResolutionVisible = true;
    },
    onMultiAssignClick(selectedCaseReports) {
      this.selectedCaseReports = selectedCaseReports;
      this.multiAssignVisible = true;
    },
    onMultiResolveConfirmed(status, comment) {
      this.multiResolutionLoading = true;

      let caseReportIds = this.selectedCaseReports.map(function (aCase) {
        return aCase.id;
      });

      this.updateCaseReportStatus({
        caseReportIds: caseReportIds,
        status: status,
        comment: { comment: comment },
      })
        .then((/*resp*/) => {
          this.setGlobalAlert({
            alert: true,
            color: "black",
            alertMessage: "Case reports updated",
          });
        })
        .catch((/*error*/) => {
          this.setGlobalAlert({
            alert: true,
            color: "red",
            alertTitle: "Oops.",
            alertMessage:
              "Unable to update case report status, please try again.",
          });
        })
        .finally(() => {
          this.selectedCaseReports = [];
          this.multiResolutionVisible = false;
          this.multiResolutionLoading = false;
        });
    },
    onMultiResolveCancelled() {
      this.multiResolutionVisible = false;
    },
    onMultiAssignConfirmed(assignedToUserName, comment) {
      this.multiAssignLoading = true;

      let caseReportIds = this.selectedCaseReports.map(function (aCase) {
        return aCase.id;
      });

      this.assignCaseReports({
        caseReportIds: caseReportIds,
        assignedToUserName: assignedToUserName,
        comment: { comment: comment },
      })
        .then((/*resp*/) => {
          this.setGlobalAlert({
            alert: true,
            color: "black",
            alertMessage: this.$t("modal.multiAssign.alert.success"),
          });
        })
        .catch((/*error*/) => {
          this.setGlobalAlert({
            alert: true,
            color: "red",
            alertTitle: "Oops.",
            alertMessage: this.$t("error.general.unhandled"),
          });
        })
        .finally(() => {
          this.selectedCaseReports = [];
          this.multiAssignVisible = false;
          this.multiAssignLoading = false;
        });
    },
    onMultiAssignCancelled() {
      this.multiAssignVisible = false;
    },
  },
};
</script>